"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserWindowId = void 0;
var uuid_1 = require("uuid");
var key = 'browser-window-id';
exports.browserWindowId = (function () {
    try {
        var value = window.sessionStorage.getItem(key);
        if (value !== null && value !== '') {
            return value;
        }
        value = (0, uuid_1.v4)();
        window.sessionStorage.setItem(key, value);
        return value;
    }
    catch (e) {
        return (0, uuid_1.v4)();
    }
})();
